import React, { Fragment } from 'react'
import { Col, Card, Row, Input, CardBody, CardHeader, FormGroup, Label, Button } from 'reactstrap';
import { useReportDevolutions } from '../../../hooks/Pbi/useReportDevolutions';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from 'primereact/tabview';
import { Chart } from 'primereact/chart';



export const IndexReportDevolutions = () => {

    const {
        setFilters, filters, loadingCancell,
        chartDataDevolution, chartOptionsDevolution, globalDevolutionFilter,
        chartDevolutionRef, handleReport, exportToExcelDevolution, setGlobalDevolutionFilter,
        devolutionPatient,
        handleViewCard, handleCloseCard, viewCard,

    } = useReportDevolutions();

    const formatAmount = (amount) => {
        return amount.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }


    const customBody = (rowData) => {
        return (
            <div className="nim-box">
                {rowData.nim}
            </div>
        );
    };



    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/cash-money.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Reporte de Devoluciones
                                    </h4>
                                    <small style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Análisis detallado de las devoluciones realizadas en el sistema.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // *REPORT
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>
                        <Row>
                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                            </Label>
                                            <Input
                                                type='date'
                                                value={filters.dateStart}
                                                onChange={(e) => {
                                                    setFilters({ ...filters, dateStart: e.target.value })
                                                }}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                            </Label>
                                            <Input
                                                type='date'
                                                value={filters.dateEnd}
                                                onChange={(e) => {
                                                    setFilters({ ...filters, dateEnd: e.target.value })
                                                }}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>

                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />
                                        <Button
                                            onClick={() => handleReport()}

                                            color="primary"
                                            block
                                            outline
                                            className="mb-3"
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Buscar
                                        </Button>

                                        {
                                            viewCard && <Button
                                                onClick={() => handleCloseCard()}

                                                color="dark"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <i className="fa fa-file-archive-o"></i>&ensp;
                                                Reporte
                                            </Button>
                                        }
                                        {
                                            !viewCard && <Button
                                                onClick={() => handleViewCard()}

                                                color="dark"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <i className="pi pi-chart-bar"></i>&ensp;
                                                Graficos
                                            </Button>

                                        }

                                        <Button
                                            color="success"
                                            onClick={() => exportToExcelDevolution(devolutionPatient)}
                                            block
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                transition: 'all 0.3s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            title="Descargar reporte"
                                        >
                                            <i className="pi pi-file-excel"></i>&ensp;
                                            Descargar
                                        </Button>

                                    </CardBody>


                                </Card>
                            </Col>

                            <Col sm="10">
                                {/* <div style={{
                                    marginTop: '1px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff'
                                }}> */}
                                    <Col sm="12" className='dark-mode-cancell'>
                                        {viewCard && (
                                            <Col sm="12">
                                                <Card className="border-0 shadow-sm">
                                                    <CardBody>
                                                        <div className="mb-4">
                                                            <h5 className="fw-bold mb-1">Devoluciones por Responsable</h5>
                                                            <small className="text-muted">
                                                                Análisis de montos devueltos y número de aplicaciones
                                                            </small>
                                                        </div>
                                                        <Row>
                                                            <Col md="6">
                                                                <Chart
                                                                    type="bar"
                                                                    data={chartDataDevolution}
                                                                    ref={chartDevolutionRef}
                                                                    options={chartOptionsDevolution}
                                                                />
                                                            </Col>

                                                            <Col md="6">
                                                                <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                                                                    {chartDataDevolution?.labels?.map((name, index) => (
                                                                        <div
                                                                            key={index}
                                                                            className="card-devolution d-flex justify-content-between align-items-center mb-2 p-3 rounded"
                                                                            >
                                                                            <div>
                                                                                <strong className="d-block">
                                                                                    #{index + 1} {name}
                                                                                </strong>
                                                                                <small className="text-muted">
                                                                                    Veces aplicado:{" "}
                                                                                    <span className="text-primary fw-bold">
                                                                                        {chartDataDevolution.datasets[1].data[index]}
                                                                                    </span>
                                                                                </small>
                                                                            </div>

                                                                            <div className="text-end">
                                                                                <span className="fw-bold text-success fs-6">
                                                                                    ${chartDataDevolution.datasets[0].data[index].toFixed(2)}
                                                                                </span>
                                                                                <div className="text-muted" style={{ fontSize: "12px" }}>
                                                                                    Total devuelto
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        )}

                                        {
                                            !viewCard && <DataTable
                                                className="data-table"
                                                globalFilter={globalDevolutionFilter}
                                                value={devolutionPatient}
                                                paginator
                                                rows={8}
                                                stripedRows
                                                rowsPerPageOptions={[8, 10, 20, 30, 40, 50]}
                                                emptyMessage={
                                                    <div className="text-center">
                                                        <img
                                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                            style={{ width: "25%" }}
                                                            alt="Sin resultados"
                                                        />
                                                        <br />
                                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún devolucion.</p>
                                                    </div>
                                                }
                                                loading={loadingCancell}
                                                loadingIcon="pi pi-spin pi-spinner"

                                            >
                                                <Column
                                                    header="#"
                                                    body={(rowData, { rowIndex }) => rowIndex + 1}
                                                    style={{
                                                        textAlign: "center",
                                                        fontSize: "12px",
                                                        width: "9%",
                                                    }}
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "12px",
                                                    }}
                                                />
                                                <Column
                                                    field="nim"
                                                    header="Nim"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "12px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                    body={customBody}
                                                />
                                                <Column
                                                    field="branch"
                                                    header="Sucursal"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />
                                                <Column
                                                    field="name_patient"
                                                    header="Paciente"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />


                                                <Column
                                                    field="type"
                                                    header="Tipo de ingreso"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />
                                                <Column
                                                    field="amount"
                                                    header="Monto"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                    body={(rowData) => `$${formatAmount(rowData.amount)}`}
                                                />
                                                <Column
                                                    field="reazon_cancellation"
                                                    header="Motivo de devolución"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />
                                                <Column
                                                    field="user_autorized"
                                                    header="Responsable"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "10px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />
                                                <Column
                                                    field="date_cancellation"
                                                    header="Fecha de devolución"
                                                    sortable
                                                    headerStyle={{
                                                        backgroundColor: "#1d5b83",
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                        padding: "5px",
                                                    }}
                                                    style={{
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        width: "10%",
                                                    }}
                                                />
                                            </DataTable>
                                        }
                                    </Col>


                                {/* </div> */}
                            </Col>

                        </Row>
                    </Col>
                </Card>
            </div>
        </div>
    )
}

